import React, { useState } from "react";
import ContractViewer from "../components/ContractViewer";

const ITEMS = [
  {
    id: 2,
    title: "Industrial Award",
    description: "Cleaning services award",
    users: "Click to see below",
    pdfUrl: "https://staffcontracts.s3.ap-southeast-2.amazonaws.com/payguides_MA000022.pdf",
  },
  {
    id: 3,
    title: "Handbook",
    description: "Company & employee handbook",
    users: "Click to see below",
    pdfUrl: "https://staffcontracts.s3.ap-southeast-2.amazonaws.com/Employee_Handbook.pdf",
  },
  {
    id: 4,
    title: "Policies",
    description: "Company policies & procedures",
    users: "Click to see below",
    pdfUrl: "https://staffcontracts.s3.ap-southeast-2.amazonaws.com/Process_Company_Policies.pdf",
  },
  {
    id: 5,
    title: "Fair Work",
    description: "Fairwork Australia",
    users: "Turn off vpn to access",
    external: true,
  },
];

const DocPolicies = () => {
  const [activeId, setActiveId] = useState(null);

  const handleClick = (item) => {
    if (item.external) {
      window.open("https://www.fairwork.gov.au/", "_blank");
      return;
    }
    setActiveId((prev) => (prev === item.id ? null : item.id));
  };

  const activeItem = ITEMS.find((i) => i.id === activeId);
  const pdfUrl = activeItem && !activeItem.external ? activeItem.pdfUrl : null;

  return (
    <div style={s.wrapper}>
      <h2 style={s.title}>Documents & Policies</h2>
      <p style={s.subtitle}>
        Access company documents, awards and policies
      </p>

      {/* ── Info Section ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Resources</div>
        <p style={s.infoText}>
          Select a document below to preview it, or visit Fair Work Australia
          for external resources.
        </p>
      </div>

      {/* ── Buttons ── */}
      <div style={s.section}>
        <div style={s.sectionLabel}>Documents</div>
        <div style={s.cardGrid}>
          {ITEMS.map((item) => {
            const isActive = activeId === item.id;
            return (
              <button
                key={item.id}
                onClick={() => handleClick(item)}
                style={{
                  ...s.card,
                  ...(isActive ? s.cardActive : {}),
                }}
              >
                <div style={s.cardIcon}>
                  {item.external ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                      <polyline points="10 9 9 9 8 9" />
                    </svg>
                  )}
                </div>
                <div style={s.cardContent}>
                  <span style={s.cardTitle}>{item.title}</span>
                  <span style={s.cardDesc}>{item.description}</span>
                  <span style={s.cardHint}>{item.users}</span>
                </div>
                {isActive && (
                  <div style={s.activeDot} />
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* ── PDF Viewer ── */}
      {pdfUrl && (
        <div style={{ paddingBottom: 24, marginTop: 24 }}>
          <ContractViewer
            pdfUrl={pdfUrl}
            height="400px"
            borderRadius="18px"
            onClose={() => setActiveId(null)}
          />
        </div>
      )}
    </div>
  );
};

/* ── Styles matching RecordMeetingFrom / formStyles pattern ── */
const s = {
  wrapper: {
    padding: "24px 20px 40px",
    maxWidth: 720,
    margin: "0 auto",
    fontFamily: "'DM Sans', sans-serif",
    color: "#f1f5f9",
  },
  title: {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: "#f1f5f9",
    marginBottom: 4,
    marginTop: 0,
  },
  subtitle: {
    fontSize: "0.8rem",
    color: "rgba(255,255,255,0.45)",
    marginBottom: 24,
    marginTop: 0,
  },
  section: {
    marginBottom: 28,
  },
  sectionLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#22d3ee",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginBottom: 14,
    marginTop: 0,
  },
  infoText: {
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.55)",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 0,
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    padding: "18px 14px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    textAlign: "center",
    fontFamily: "'DM Sans', sans-serif",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  cardActive: {
    border: "1px solid rgba(34,211,238,0.5)",
    background: "rgba(34,211,238,0.08)",
    boxShadow: "0 0 20px rgba(34,211,238,0.1)",
  },
  cardIcon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: "rgba(34,211,238,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  cardTitle: {
    fontSize: "0.88rem",
    fontWeight: 600,
    color: "#e2e8f0",
  },
  cardDesc: {
    fontSize: "0.75rem",
    color: "rgba(255,255,255,0.45)",
  },
  cardHint: {
    fontSize: "0.7rem",
    color: "rgba(34,211,238,0.6)",
    marginTop: 2,
  },
  activeDot: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#22d3ee",
    boxShadow: "0 0 6px rgba(34,211,238,0.6)",
  },
};

export default DocPolicies;